import { MODULE_STORE_KEY } from '../constants';
import type { ModuleExpanded } from './expandModule';

export default (state: GlobalState) => state[MODULE_STORE_KEY] as ModuleExpanded[];
